import { render, staticRenderFns } from "./GenerateRewardsModal.vue?vue&type=template&id=1ee1b141&"
import script from "./GenerateRewardsModal.vue?vue&type=script&lang=js&"
export * from "./GenerateRewardsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports